import { hooks as authHooks } from '../../App/ducks/authDuck';

export const useToken = () => {
  return authHooks.useTokenSelector();
};
